/** Longer than this, say so instead of leaving the save button spinning */
const MAX_WAIT_MS = 15_000;

/**
 * How long Stoat asked to wait, when this error is its "too fast" answer. The
 * SDK throws the response's text as it came.
 */
function retryAfter(error: unknown): number | undefined {
  let body = error;
  if (typeof error === "string") {
    try {
      body = JSON.parse(error);
    } catch {
      return undefined;
    }
  }
  const wait = (body as { retry_after?: unknown } | null)?.retry_after;
  return typeof wait === "number" && wait >= 0 ? wait : undefined;
}

/**
 * Konkord: a save right after another one gets Stoat's "too fast" answer. Wait
 * what it asked and try again, so the person's change isn't lost.
 */
export async function retryRateLimited<T>(
  run: () => Promise<T>,
  tries = 3,
  sleep = (ms: number) =>
    new Promise<void>((done) => setTimeout(done, ms)),
): Promise<T> {
  for (let attempt = 1; ; attempt++) {
    try {
      return await run();
    } catch (error) {
      const wait = retryAfter(error);
      if (wait === undefined || wait > MAX_WAIT_MS || attempt >= tries) {
        throw error;
      }
      await sleep(wait + 200);
    }
  }
}
